<div class="versions-tab">
  <nz-table
    #versionsTable
    [nzData]="versions"
    [nzLoading]="loading"
    [nzShowPagination]="false"
    [nzFrontPagination]="false"
    [nzNoResult]="noResult"
  >
    <thead>
      <tr>
        <th>Versión</th>
        <th>Fecha de emisión</th>
        <th>Vencimiento</th>
        <th>Autor</th>
        <th>Moneda</th>
        <th>Tipo de cambio</th>
        <th>Fecha de conversión</th>
        <th class="actions-col"></th>
      </tr>
    </thead>
    <tbody>
      @for (version of versionsTable.data; track version.id) {
        <tr class="version-row">
          <td>{{ formatLabel(version.versionNumber) }}</td>
          <td>{{ formatIssuedOn(version.issuedOn) }}</td>
          <td>{{ formatExpiration(version.expirationDate) }}</td>
          <td>{{ version.createdBy }}</td>
          <td>{{ formatCurrency(version) }}</td>
          <td>{{ formatRate(version.exchangeRate) }}</td>
          <td>{{ formatConversionDate(version.conversionDate) }}</td>
          <td class="actions-col">
            <button
              nz-button
              nzType="text"
              class="download-btn"
              [nzLoading]="downloadingId === version.id"
              [disabled]="downloadingId !== null"
              (click)="downloadVersion(version)"
              title="Descargar"
            >
              <app-st-icon name="download"></app-st-icon>
            </button>
            <button
              nz-button
              nzType="text"
              nzDanger
              class="archive-btn"
              [nzLoading]="archivingId === version.id"
              [disabled]="archivingId !== null"
              (click)="confirmArchiveVersion(version)"
            >
              Eliminar
            </button>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>

  <ng-template #noResult>
    @if (loadFailed) {
      <nz-empty nzNotFoundContent="No se pudieron cargar las versiones."></nz-empty>
    } @else if (isEmpty) {
      <nz-empty nzNotFoundContent="Todavía no se ha generado ninguna versión de este presupuesto."></nz-empty>
    }
  </ng-template>
</div>

<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
    [showUndo]="toastConfig.showUndo" [notRef]="notRef" [content]="toastConfig.content"
    [msg]="toastConfig.msg"></app-toast>
</ng-template>
